import type {ComputingCodeMultiFile} from "#content-library/types/types.ts";

/**
 * Get the name of the file that is to the left of the given file. Wraps around
 * to the end if the first file is passed in.
 * @param code All of the code for the program.
 * @param filename The starting filename.
 */
export const getPrevFilename = (
    code: ComputingCodeMultiFile,
    filename: string,
): string => {
    if (code.files.length === 0) {
        return "";
    }

    const index = code.files.findIndex((file) => file.filename === filename);
    if (index === -1) {
        return "";
    }

    if (index > 0) {
        return code.files[index - 1].filename;
    }

    // Wrap around to the last file
    return code.files[code.files.length - 1].filename;
};

/**
 * Get the name of the file that is to the right of the given file. Wraps around
 * to the beginning if the last file is passed in.
 * @param code All of the code for the program.
 * @param filename The starting filename.
 */
export const getNextFilename = (
    code: ComputingCodeMultiFile,
    filename: string,
): string => {
    if (code.files.length === 0) {
        return "";
    }

    const index = code.files.findIndex((file) => file.filename === filename);
    if (index === -1) {
        return "";
    }

    if (index < code.files.length - 1) {
        return code.files[index + 1].filename;
    }

    // Wrap around to the first file
    return code.files[0].filename;
};

/**
 * Gets the numeric index of the file in the list, given the filename.
 * @param code All of the code for the program.
 * @param filename The name of the file to get the index of.
 */
export const getFileIndex = (
    code: ComputingCodeMultiFile,
    filename: string,
): number => {
    return code.files.findIndex((file) => file.filename === filename);
};
